import { render, staticRenderFns } from "./InventoryReport.vue?vue&type=template&id=d5fc67fa&scoped=true&"
import script from "./InventoryReport.vue?vue&type=script&lang=js&"
export * from "./InventoryReport.vue?vue&type=script&lang=js&"
import style0 from "./InventoryReport.vue?vue&type=style&index=0&id=d5fc67fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fc67fa",
  null
  
)

export default component.exports